// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dashboard_wrapper__3kXJh","sidenav":"dashboard_sidenav__2dCo7","content":"dashboard_content__ujBK0"};